import { DatatableContextProvider } from "@/components/tables/contexts/DatatableContextProvider";
import DatabricksQueriesContent from "./DatabricksQueriesContent";

const DatabricksQueries = () => {
  return (
    <DatatableContextProvider>
      <DatabricksQueriesContent />
    </DatatableContextProvider>
  );
};

export default DatabricksQueries;
